var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ai-catalog-mcp-servers-index',{attrs:{"mcp-servers":_vm.projectMcpServers,"page-info":_vm.pageInfo,"is-loading":_vm.isLoading,"description":_vm.$options.description,"empty-state-description":_vm.$options.emptyStateDescription},on:{"next-page":_vm.handleNextPage,"prev-page":_vm.handlePrevPage,"connect":_vm.handleConnect}})
}
var staticRenderFns = []

export { render, staticRenderFns }